<template>
  <v-container>
    <v-row align="center">
      <v-col cols="6">
        <v-row no-gutters align="center">
          <MediaFilePicker
            :label="'Изображение'"
            :multiple="false"
            :isShowCaption="true"
            :file-type="$options.mediaTypesByKeys.IMAGE"
            :value="listItem.data.image"
            :caption="listItem.data.caption"
            @change="mixUploadImageHandler($event, 'image')"
            @change-caption="mixChangeListItemHandler($event, 'caption')"
          >
            <template #preview-bottom>
              <ErrorMessage :message="errorMessages.image" />
            </template>
          </MediaFilePicker>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <span>Заполнение изображения</span>
        <v-select
          outlined
          item-value="value"
          item-text="title"
          return-object
          hide-details
          dense
          :disabled="isLoading"
          :loading="isLoading"
          :value="listItem.data.fit"
          :items="$options.imageFits"
          @change="mixChangeListItemHandler($event, 'fit')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <span>Ширина</span>
        <v-text-field
          outlined
          dense
          :disabled="isLoading"
          :loading="isLoading"
          :value="fields.inputWidth"
          :error-messages="errorMessages.width"
          @input="ChangingHandler($event, 'Width', 'input')"
        />
      </v-col>
      <v-col cols="6">
        <span>Ед. измерения</span>
        <v-select
          outlined
          item-value="value"
          item-text="title"
          hide-details
          dense
          :disabled="isLoading"
          :loading="isLoading"
          :value="fields.valueWidth"
          :items="$options.valueTypesCSSList"
          @change="ChangingHandler($event, 'Width', 'value')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <span>Высота</span>
        <v-text-field
          outlined
          dense
          :disabled="isLoading"
          :loading="isLoading"
          :value="fields.inputHeight"
          :error-messages="errorMessages.height"
          @input="ChangingHandler($event, 'Height', 'input')"
        />
      </v-col>
      <v-col cols="6">
        <span>Ед. измерения</span>
        <v-select
          outlined
          item-value="value"
          item-text="title"
          hide-details
          dense
          :disabled="isLoading"
          :loading="isLoading"
          :value="fields.valueHeight"
          :items="$options.valueTypesCSSList"
          @change="ChangingHandler($event, 'Height', 'value')"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import dynamicListItemMix from '@/mixins/dynamic-list/dynamicListItem.mix.js'

import imageFits from '@/configs/imageFits'
import { mediaTypesByKeys } from '@/configs/mediaFileTypes'
import valueTypesCSSList from '@/configs/valueTypesCSS'

import MediaFilePicker from '@/components/media-file-picker/MediaFilePicker.vue'
import ErrorMessage from '@/components/error-messages/ErrorMessage'
const regex = /(px|em|%|in|pt+)$/gim

export default {
  name: 'ImageWidget',
  mixins: [dynamicListItemMix],
  mediaTypesByKeys: mediaTypesByKeys(),
  imageFits,
  valueTypesCSSList,
  components: {
    ErrorMessage,
    MediaFilePicker
  },
  data () {
    return {
      fields: {
        valueWidth: null,
        valueHeight: null,
        inputWidth: null,
        inputHeight: null
      }
    }
  },
  computed: {
    returnWidth () {
      return this?.listItem?.data?.width.toString() || null
    },
    returnHight () {
      return this?.listItem?.data?.height.toString() || null
    }
  },
  methods: {
    populateSize (field) {
      switch (field) {
        case 'width':
          this.fields.inputWidth = this.returnWidth?.replace(regex, '')
          if (this.returnHight?.match(regex)) {
            this.fields.valueHeight = this.returnHight?.slice(
              this.returnHight?.search(regex)
            )
          } else {
            this.fields.valueHeight = 'px'
          }
          break
        case 'height':
          this.fields.inputHeight = this.returnHight?.replace(regex, '')
          this.fields.valueHeight = this.returnHight?.slice(
            this.returnHight?.search(regex)
          )
          break
        default:
          break
      }
      this.inputWidth = this.returnWidth?.replace(regex, '')
      const idxWidth = this.returnWidth?.search(regex)
      this.valueWidth = this.returnWidth?.slice(idxWidth)
    },
    ChangingHandler (payload, field = 'Width', typeSize = 'input') {
      const stateField = `${typeSize}${field}`
      this.fields[stateField] = payload
      this.mixChangeListItemHandler(
        String(this.fields[`input${field}`] + this.fields[`value${field}`]).trim(),
        field.toLowerCase()
      )
    }
  },
  mounted () {
    this.populateSize('width')
    this.populateSize('height')
  }
}
</script>
